<!-- @format -->
<template>
  <footer>
    <div class="yingda-content" v-if="isYingda">
      <div class="top">
        <div class="item">
          <span>合作高校</span>
          <em>1000+</em>
        </div>
        <div class="item">
          <span>覆盖学生</span>
          <em>100万+</em>
        </div>
        <div class="item">
          <span>网络招聘会</span>
          <em>2万+</em>
        </div>
        <div class="item">
          <span>线下招聘会</span>
          <em>100+</em>
        </div>
      </div>
    </div>
    <div class="footer-content" v-else>
      <div class="left">
        <div class="top">
          <div class="item">
            <em>1000+</em>
            <span>合作高校</span>
          </div>
          <div class="item">
            <em>100万+</em>
            <span>覆盖学生</span>
          </div>
          <div class="item">
            <em>2万+</em>
            <span>网络招聘会</span>
          </div>
          <div class="item">
            <em>100+</em>
            <span>线下招聘会</span>
          </div>
        </div>
        <div class="bottom">
          <span v-if="yishengyice">©就业育人 备案号：沪ICP备20024996号</span>
          <span v-else>©毕业申 备案号：沪ICP备17007916号-3</span>
        </div>
      </div>
      <div class="right">
        <div class="contact">
          <div class="contact-item">
            <i class="iconfont icon_weixin"></i>
            <span>{{ $route.name === 'create' ? defaultWechat : configWechat }}</span>
          </div>
          <div class="contact-item">
            <i class="iconfont icon_youxiang"></i>
            <span>info@applyoffer.com</span>
          </div>
          <div class="contact-item">
            <i class="iconfont icon_dianhua"></i>
            <span>021-66696957 (9:00-18:00)</span>
          </div>
        </div>
        <div class="wechat">
          <img src="@/assets/image/newimg.png" alt="" />
          <div class="account">
            <h3 class="tit">关注公众号</h3>
            <ul>
              <li>随时报名招聘会</li>
              <li>随时处理简历</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      yishengyice: false,
      isYingda: false,
      platform: '',
      wechat: ''
    }
  },
  created () {
    if (sessionStorage.getItem('yishengyice') === '1') {
      this.yishengyice = true
    }
    this.isYingda = location.host.split('.')[0] === 'xinmubiao'
  },
  computed: {
    defaultWechat () {
      return this.$store.state.user.siteInfo.company_concat_link
    },
    configWechat () {
      return this.$store.state.company.basicInfo.company_concat_link
    }
  }
}
</script>

<style scoped lang="less">
footer {
  background-color: #fafafa;
  .footer-content {
    width: 1200px;
    height: 175px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    .left {
      .top {
        padding: 40px 0 25px 0;
        display: flex;
        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          color: #515a6e;
          line-height: 1;
          margin-right: 100px;
          em {
            font-size: 18px;
            font-weight: bold;
            font-style: normal;
          }
          span {
            margin-top: 17px;
            font-size: 14px;
          }
        }
      }
      .bottom {
        border-top: 1px solid #f2f3f6;
        font-size: 12px;
        color: #808695;
        display: flex;
        line-height: 62px;
      }
    }
    .right {
      display: flex;
      padding: 35px 0;
      line-height: 1;
      .contact {
        .contact-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          span {
            margin-left: 12px;
            font-size: 14px;
            color: #515a6e;
          }
          i {
            font-size: 24px;
            color: #8d92a1;
            &.youxiang {
              font-size: 20px;
            }
          }
        }
      }
      .wechat {
        margin-left: 48px;
        display: flex;
        img {
          width: 88px;
          height: 88px;
        }
        .account {
          padding:11px 0 11px 24px;
          box-sizing: border-box;
          .tit {
            font-size: 14px;
            font-weight: bold;
            color: #808695;
            line-height: 14px;
          }
          ul {
            margin-top: 12px;
            li {
              font-size: 12px;
              color: #808695;
              line-height: 20px;
              position: relative;
              list-style: none;
              &:after {
                content: '';
                display: inline-block;
                width: 4px;
                height: 4px;
                background: #D8D8D8;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: -8px;
                transform: translateY(-50%);
              }
            }
          }
        }
      }
    }
  }

  .yingda-content {
    height: 98px;
    display: flex;
    align-items: center;
    justify-content: center;
    .top {
      display: flex;
      color: #515a6e;
      .item {
        margin-left: 180px;
        &:nth-child(1) {
          margin-left: 0;
        }
        span {
          font-size: 14px;
        }
        em {
          font-style: normal;
          font-size: 18px;
          margin-left: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/footer.vue